import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GetAllInvestorsApi, GetInvestorByIdApi } from "../../ApiRequests";

export const fetchInvestor = createAsyncThunk("fetch/Investor", async (id) => {
  try {
    let response;
    if (id) response = await GetInvestorByIdApi(id);
    else response = await GetAllInvestorsApi();
    return response?.data?.data.payload;
  } catch (error) {
    console.log(error);
  }
  return [];
});

const InvestorSlice = createSlice({
  name: "Investor",
  initialState: {
    loading: false,
    data: [],
    isError: false,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchInvestor.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchInvestor.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.isError = false;
    });
    builder.addCase(fetchInvestor.rejected, (state, action) => {
      state.loading = false;
      state.isError = true;
    });
  },
});

export default InvestorSlice.reducer;
